import { useParams } from "react-router";
import { InviteAccept } from "@/components/app/team/InviteAccept";
import { usePageTitle } from "../hooks/usePageTitle";

export function InviteAcceptPage() {
  usePageTitle("Join Team | TidyRota");
  const { token } = useParams<{ token: string }>();

  if (!token) return null;

  return <InviteAccept token={token} />;
}
